import { createContext } from "react";
import { defaultAgentReport } from "../../calculations/teamCalculations";
import { AgentReport } from "../../models/reports.agents";

export const AgentReportContext = createContext<AgentReport>(defaultAgentReport(""));
